import React from 'react'
import bannerBg from '../assets/img/corp-val.png';
import PageBanner from '../Components/PageBanner';
import MyFaq from '../Components/Faq/MyFaq';
import CorporateFaq from '../Components/Faq/CorporateFaq';
import BrandCarouselTwo from '../Components/Brands/BrandCarouselTwo';
import BrandLogos from '../Components/Brands/BrandLogos';
import CompanyIcons from '../Components/Price/CompanyIcons';

const CorporateValue = () => {
  return (
    <>
       <PageBanner title='Corporate Value  ' bannerBg={bannerBg} currentPage='Corporate Value ' />
       <CorporateFaq/>
       <BrandLogos/>
        {/* <div className='space'></div> */}
        <CompanyIcons/>
    </>
  )
}

export default CorporateValue
